/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentDraftsControllerVersionQueryResponse, DocumentDraftsControllerVersionPathParams, DocumentDraftsControllerVersionQueryParams, DocumentDraftsControllerVersion400, DocumentDraftsControllerVersion401, DocumentDraftsControllerVersion403, DocumentDraftsControllerVersion404 } from "../../models/documentDraftsController/DocumentDraftsControllerVersion";

function getDocumentDraftsControllerVersionUrl(threadId: DocumentDraftsControllerVersionPathParams["threadId"], version: DocumentDraftsControllerVersionPathParams["version"]) {
  const res = { method: 'GET', url: `/api/v1/document-drafts/${threadId}/versions/${version}` as const }  
  return res
}

/**
 * {@link /api/v1/document-drafts/:threadId/versions/:version}
 */
export async function documentDraftsControllerVersion(threadId: DocumentDraftsControllerVersionPathParams["threadId"], version: DocumentDraftsControllerVersionPathParams["version"], params: DocumentDraftsControllerVersionQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentDraftsControllerVersionQueryResponse, ResponseErrorConfig<DocumentDraftsControllerVersion400 | DocumentDraftsControllerVersion401 | DocumentDraftsControllerVersion403 | DocumentDraftsControllerVersion404>, unknown>({ method : "GET", url : getDocumentDraftsControllerVersionUrl(threadId, version).url.toString(), params, ... requestConfig })  
  return res.data
}